import api from "./api";

const CHUNK_SIZE = 4 * 1024 * 1024;

export async function uploadVideoChunked(file, onProgress) {
  const { data: init } = await api.post("/uploads/video/init", {
    content_type: file.type,
    size: file.size,
    filename: file.name,
  });
  const total = Math.ceil(file.size / CHUNK_SIZE);
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", init.upload_id);
    fd.append("index", String(i));
    fd.append("chunk", file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE));
    await api.post("/uploads/video/chunk", fd, { headers: { "Content-Type": "multipart/form-data" } });
    onProgress?.(Math.round(((i + 1) / total) * 90));
  }
  onProgress?.(95);
  const { data } = await api.post("/uploads/video/complete", { upload_id: init.upload_id });
  onProgress?.(100);
  return data;
}
